<template>
  <common title="信息提交">
    <div class="faceSubmission">
      <div class="submit-t">
        <div class="submit-img">
          <img :src="aoiUserInfoForm.facePic" alt="" />
        </div>
        <div class="submit-content">
          <div class="item">
            <div class="label">昵称：</div>
            <input v-model.trim="aoiUserInfoForm.nickName" type="text" />
          </div>
          <div class="item">
            <div class="label">手机号：</div>
            <input v-model.trim="aoiUserInfoForm.mobileNum" type="text" />
          </div>
          <div class="item">
            <div class="label">房号：</div>
            <div class="roomSelect">
              <div class="room" @click="isShowCas = true">{{ houseName }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-b">
        <div class="btn confirm" @click="confirmSure">确认提交</div>
        <div class="btn cancel" @click="$router.back()">取消返回</div>
      </div>
    </div>
    <div class="popup">
      <van-popup v-model="isShowCas" round position="bottom">
        <van-cascader
          v-model="aoiUserInfoForm.spaceId"
          :field-names="fieldNames"
          title="请选择所在房号"
          active-color="#1989fa"
          :options="areaItemList"
          @close="isShowCas = false"
          @change="change"
          @finish="onFinish"
        />
      </van-popup>
    </div>
  </common>
</template>

<script>
import Vue from "vue";
import { Cascader, Popup } from "vant";
Vue.use(Cascader);
Vue.use(Popup);
import storage from "../utils/storage";
import common from "../components/common.vue";
import { areaLinkUrl, aoiRegister } from "./api.js";
export default {
  name: "faceSubmission",
  components: {
    common,
  },
  props: {},
  data() {
    return {
      houseName: "", //房号
      isShowCas: false, //控制选择房号弹窗
      areaItemList: [], //社区房号信息
      fieldNames: {
        text: "name",
        value: "id",
        children: "children",
      },
      aoiUserInfoForm: {
        deviceNo: storage.get("deviceNo") || "",
        facePic: "",
        nickName: "",
        mobileNum: "",
        spaceId: "",
        registerType: 2, //注册方式 1身份证 2人脸 3手机号
      },
      localPath: "",
      hasChildren: true,
    };
  },
  created() {},
  mounted() {
    const faceInfo = storage.get("faceInfo");
    this.aoiUserInfoForm.facePic = faceInfo.facePic;
    this.localPath = faceInfo.localPath;
    this.getRoomList();
    window.onFaceAdd = this.onFaceAdd;
    window.onImageRecognized = this.onImageRecognized;
  },
  methods: {
    change(data) {
      if (data.selectedOptions && data.selectedOptions[data.tabIndex]) {
        if (!data.selectedOptions[data.tabIndex].hasChildren) {
          this.hasChildren = false;
        } else {
          this.hasChildren = true;
        }
      }
    },
    //校验字段
    verifyFields() {
      let result = true;
      if (!this.localPath || this.localPath == "") {
        this.$toast({ message: "请先拍照", duration: 2000 });
        return;
      }
      if (!this.aoiUserInfoForm.nickName) {
        this.$toast({ message: "请输入昵称", duration: 2000 });
        result = false;
        return;
      }
      if (!this.aoiUserInfoForm.mobileNum) {
        this.$toast({ message: "请输入手机号", duration: 2000 });
        result = false;
        return;
      }
      if (!/^(1)\d{10}$/.test(this.aoiUserInfoForm.mobileNum)) {
        this.$toast({
          message: "请输入正确的手机号",
          duration: 3000,
        });
        return;
      }
      if (!this.aoiUserInfoForm.spaceId) {
        this.$toast({ message: "请选择房号", duration: 2000 });
        result = false;
        return;
      }
      if (this.hasChildren) {
        this.$toast({ message: "请选择房号", duration: 5000 });
        result = false;
        return;
      }
      return result;
    },
    //确认注册
    confirmSure() {
      const result = this.verifyFields();
      if (result) {
        window.sys.recognizeImage(this.localPath);
      }
    },
    onImageRecognized(localPath, result) {
      if (result == 1) {
        this.aoiRegister(localPath);
        //先调用本地入库，异步等待结果
      }
    },
    //监听是否入库
    onFaceAdd(localPath, result) {
      if (result == 1) {
        this.$router.push({
          name: "guidePage",
        });
      }

      //result  1-成功，-1 当前用户已经注册, -2 图片入库失败 -3人脸未找到
    },
    //人脸注册
    async aoiRegister(localPath) {
      const res = await this.$axios.post(aoiRegister, this.aoiUserInfoForm);
      if (res.code == 200) {
        const { data } = res;
        window.sys.addFace(localPath, data.userId);
        storage.set("systemUserInfo", data);
        this.$store.commit("setUserId", data.userId);
        this.$store.commit("setHouseId", data.houseId);
        this.$store.commit("setTenantId", data.tenantId);
        this.$store.commit("setCommunityId", data.communityId);
        this.$store.commit("setsessionKey", data.sessionKey);
        this.$store.commit("setsessionId", data.sessionId);
      }
    },
    //勾选完成
    onFinish({ selectedOptions }) {
      this.isShowCas = false;
      this.houseName = selectedOptions.map((option) => option.name).join("-");
    },

    //获取房号
    getRoomList() {
      this.$axios
        .get(`${areaLinkUrl}?specifyCollectionTypes=1&topSpaceId=P1C2A2S1D1`)
        .then((res) => {
          if (res.code == 200) {
            this.areaItemList = res.data;
          }
        });
    },
  },
};
</script>

<style scoped lang="less">
.faceSubmission {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 59px 121px 57px 141px;
  box-sizing: border-box;
  .submit-t {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    align-items: flex-start;
    .submit-img {
      margin-right: 62px;
      width: 263px;
      height: 287px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .submit-content {
      width: calc(100% - 263px);

      .item {
        width: 100%;
        justify-content: center;
        display: flex;
        align-items: center;
        &:not(:last-child) {
          margin-bottom: 15px;
        }
      }
      .roomSelect {
        margin-left: 15px;
        flex: 1;
        display: flex;
        align-items: center;
        .room {
          width: 100%;
          height: 50px;
          border-radius: 6px;
          border: 1px solid #e4e7ed;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          line-height: 50px;
          color: #2f3a4f;
          text-align: left;
          padding: 0 15px;
        }
      }
      input {
        flex: 1;
        height: 50px;
        border-radius: 6px;
        border: 1px solid #e4e7ed;
        font-weight: 400;
        font-size: 16px;
        color: #000;
        font-style: normal;
        padding: 0 15px;
        margin-left: 15px;
        box-sizing: border-box;
        &::placeholder {
          font-weight: 400;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.5);
          font-style: normal;
        }
      }
      .label {
        white-space: nowrap;
        font-weight: 400;
        font-size: 16px;
        color: #2f3a4f;
        line-height: 22px;
        font-style: normal;
        width: 80px;
        text-align: right;
      }
      &:first-child {
        margin-bottom: 15px;
      }
    }
  }
  .submit-b {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 40px;
    box-sizing: border-box;
    .btn {
      width: 239px;
      height: 50px;
      box-sizing: border-box;
      background: #1874fd;
      border-radius: 6px;
      // padding: 13px 102px;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      font-style: normal;
      &:last-child {
        margin-left: 138px;
        border: 1px solid #1874fd;
        background: #ffffff;
        color: #1874fd;
      }
    }
  }
}
</style>
